import React from 'react';
import styles from './DeleteConfirmationModal.module.css';
import { logAuditEvent } from '../../utils/logAudit'; // Import the audit logging utility

const LogoutConfirmation = ({ onClose, onConfirm, loading, currentUser }) => {
  const handleConfirmWithLog = async () => {
    try {
      // Log the confirmation action
      await logAuditEvent({
        actionType: 'LOGOUT',
        entityType: 'USER',
        entityId: currentUser?.uid,
        description: 'User confirmed logout action',
        companyId: currentUser?.companyId,
        email: currentUser?.email
      });
      
      // Proceed with the original onConfirm
      onConfirm();
    } catch (error) {
      console.error('Error logging confirmation:', error);
      // Still proceed with logout even if logging fails
      onConfirm();
    }
  };

  const handleCloseWithLog = () => {
    // Log the cancellation action
    logAuditEvent({
      actionType: 'LOGOUT_CANCELLED',
      entityType: 'USER',
      entityId: currentUser?.uid,
      description: 'User cancelled logout action',
      companyId: currentUser?.companyId,
      email: currentUser?.email
    }).catch(error => console.error('Error logging cancellation:', error));
    
    // Proceed with the original onClose
    onClose();
  };

  return (
    <div className={styles.modalOverlay} role="dialog" aria-modal="true" aria-labelledby="logout-modal-title">
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3 id="logout-modal-title">Confirm Logout</h3>
          <button 
            className={styles.closeBtn} 
            onClick={handleCloseWithLog} 
            disabled={loading}
            aria-label="Close logout confirmation"
          >
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <p>Are you sure you want to log out?</p>
          <p className={styles.warningText}>
            You will need to sign in again to access your account.
          </p>
        </div>
        <div className={styles.modalFooter}>
          <button 
            className={`${styles.btn} ${styles.btnSecondary}`} 
            onClick={handleCloseWithLog}
            disabled={loading}
            aria-busy={loading}
          >
            Cancel
          </button>
          <button 
            className={`${styles.btn} ${styles.btnDanger}`} 
            onClick={handleConfirmWithLog}
            disabled={loading}
            aria-busy={loading}
          >
            {loading ? (
              <>
                <span className={styles.spinnerBorder} aria-hidden="true"></span>
                <span>Logging out...</span>
              </>
            ) : (
              'Logout'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmation;